import { MappingTabPreviewButton } from "@/components/table-preview/sidebar";
import { cn } from "@/lib/utils";
import { useMappingStore } from "@/stores/mapping";
import { SegmentItem } from "@/toggle-ui-kit/segment-control";

type MappingAxisSelectSectionProps = {
  onPreviewSidebarClick?: () => void;
  showPreviewSidebar?: boolean;
  onAutoTagClick?: () => void;
  showAutoTag?: boolean;
  autoTagAvailable?: boolean;
};

const TabButton = ({
  children,
  isActive,
  onClick,
  className,
}: {
  children: React.ReactNode;
  isActive: boolean;
  onClick: () => void;
  className?: string;
}) => {
  return (
    <button
      className={cn(
        "flex min-w-[120px] py-3 pb-2.5 px-6 justify-center items-center gap-2 outline-none border-b-2 border-b-transparent transition-colors duration-100 ",
        {
          "border-b-[3px] -mb-[1px] border-b-primary": isActive,
          "border-b-2 border-b-transparent hover:border-b-neutral-300":
            !isActive,
        },
        className,
      )}
      onClick={onClick}
    >
      <span className="body-2-normal-semibold text-primary">{children}</span>
    </button>
  );
};

export const MappingAxisSelectSection = ({
  showPreviewSidebar = false,
  onPreviewSidebarClick,
  showAutoTag = false,
  onAutoTagClick,
  autoTagAvailable = false,
}: MappingAxisSelectSectionProps) => {
  const setDimension = useMappingStore((state) => state.dimension.set);
  const dimension = useMappingStore((state) => state.dimension.dimension);

  return (
    <div className="relative flex pr-5 justify-between items-center self-stretch">
      <div className="flex items-center">
        <TabButton
          isActive={dimension === "LINE_ITEM"}
          onClick={() => setDimension("LINE_ITEM")}
        >
          행
        </TabButton>
        <TabButton
          isActive={dimension === "AXIS"}
          onClick={() => setDimension("AXIS")}
        >
          열
        </TabButton>
      </div>
      <div className="flex items-center gap-2">
        {autoTagAvailable && (
          <SegmentItem
            selected={showAutoTag}
            size="small"
            {...(onAutoTagClick ? { onClick: onAutoTagClick } : {})}
          >
            오토태깅
          </SegmentItem>
        )}
        <MappingTabPreviewButton
          selected={showPreviewSidebar}
          {...(onPreviewSidebarClick ? { onClick: onPreviewSidebarClick } : {})}
        />
      </div>
    </div>
  );
};
